import { render } from "./CorridoringMap.vue?vue&type=template&id=5f893adb"
import script from "./CorridoringMap.vue?vue&type=script&lang=js"
export * from "./CorridoringMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__